var React = require('react');

function MailIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37.6665 0.333313H4.33317C2.0415 0.333313 0.166504 2.20831 0.166504 4.49998V29.5C0.166504 31.7916 2.0415 33.6666 4.33317 33.6666H37.6665C39.9582 33.6666 41.8332 31.7916 41.8332 29.5V4.49998C41.8332 2.20831 39.9582 0.333313 37.6665 0.333313ZM36.8332 9.18748L23.2082 17.7083C21.854 18.5625 20.1457 18.5625 18.7915 17.7083L5.1665 9.18748C4.64567 8.85415 4.33317 8.29165 4.33317 7.68748C4.33317 6.29165 5.854 5.45831 7.0415 6.18748L20.9998 14.9166L34.9582 6.18748C36.1457 5.45831 37.6665 6.29165 37.6665 7.68748C37.6665 8.29165 37.354 8.85415 36.8332 9.18748Z","fill":"#E44331"}));
}

MailIcon.defaultProps = {"width":"42","height":"34","viewBox":"0 0 42 34","fill":"none"};

module.exports = MailIcon;

MailIcon.default = MailIcon;
